import React from 'react';
import { Flex } from '@react-spectrum/layout';
import { Discord } from 'app/assets/brands/Discord';
import { Reddit } from 'app/assets/brands/Reddit';
import { Twitter } from 'app/assets/brands/Twitter';
import { DividerLabel } from 'app/views/components/core/DividerLabel';
import { Text } from '../../typography/Text';
const Links = [
    { key: 'contactTwitterLink', label: 'Twitter', Icon: Twitter },
    { key: 'contactDiscordLink', label: 'Discord', Icon: Discord },
    { key: 'contactRedditLink', label: 'Reddit', Icon: Reddit },
];
export const ContactLinks = () => {
    const links = Links.map(link => ({
        key: link.key,
        label: link.label,
        value: configGet(link.key, undefined),
        Icon: link.Icon,
    })).filter(({ value }) => !!value);
    if (!links.length) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(DividerLabel, null, "or reach out directly"),
        React.createElement(Flex, { direction: "row", gap: "size-100" }, links.map(link => {
            const { Icon } = link;
            return (React.createElement("a", { className: "contact-btn", key: link.key, target: "_blank", rel: "noreferrer", href: link.value },
                React.createElement("div", { className: "icon" },
                    React.createElement(Icon, null)),
                React.createElement(Text, { size: "XS" }, link.label)));
        }))));
};
